import React from 'react';
import ReactDOM from 'react-dom';
import CategoryPageContent from "./CategoryPageContent";

var salonCountries = JSON.parse(document.getElementById("salonCountries").textContent); // eslint-disable-next-line

if (document.getElementById("breadcrumbJson") !== null) {
    var breadcrumbs = JSON.parse(document.getElementById("breadcrumbJson").textContent); // eslint-disable-next-line
}

if(document.getElementById("ListOfArticlesPageJson")) {
    var listOfArticles = JSON.parse(document.getElementById("ListOfArticlesPageJson").textContent); // eslint-disable-next-line
    ReactDOM.render(<CategoryPageContent salonCountries={salonCountries} Model={listOfArticles} breadcrumbs={breadcrumbs}/>, document.getElementById('ListOfArticles'));
}
if(document.getElementById("askAStylistPageJson") && document.getElementById("askAStylistPageIndex")) {
    var askAStylist = JSON.parse(document.getElementById("askAStylistPageJson").textContent); // eslint-disable-next-line
    ReactDOM.render(<CategoryPageContent salonCountries={salonCountries} Model={askAStylist} breadcrumbs={breadcrumbs}/>, document.getElementById('askAStylistPageIndex'));
}
if(document.getElementById("askAStylistChildPageJson") && document.getElementById("askAStylistChildPageIndex")) {
    var askAStylistChild = JSON.parse(document.getElementById("askAStylistChildPageJson").textContent); // eslint-disable-next-line
    ReactDOM.render(<CategoryPageContent salonCountries={salonCountries} Model={askAStylistChild} breadcrumbs={breadcrumbs}/>, document.getElementById('askAStylistChildPageIndex'));
}
if(document.getElementById("nioxinInTheNewsJson") && document.getElementById("nioxinInTheNewsPageIndex")) {
    var nioxinInTheNews = JSON.parse(document.getElementById("nioxinInTheNewsJson").textContent); // eslint-disable-next-line
    ReactDOM.render(<CategoryPageContent salonCountries={salonCountries} Model={nioxinInTheNews} breadcrumbs={breadcrumbs}/>, document.getElementById('nioxinInTheNewsPageIndex'));
}
